// ============================================================
// CENTRAL BRAND CONFIG — edit this ONE file to change the
// business name, tagline, contact details, services, portfolio,
// and social links across the entire website.
// ============================================================

export const brand = {
  name: "The Web Whisperer",
  tagline: "Beautiful Websites. Effortlessly Done.",
  subhead: "Professional websites that make your business look its best—without the headaches.",
  intro:
    "We design, launch, host, and maintain beautiful websites for small businesses nationwide. You focus on running your business. We'll handle your website.",

  contact: {
    email: "hello@thewebwhisperer.com",
    location: "Serving small businesses across the United States",
  },

  social: {
    instagram: "https://instagram.com/",
    facebook: "https://facebook.com/",
    linkedin: "https://linkedin.com/",
  },

  colors: {
    charcoal: "#202020",
    turquoise: "#00AFA3",
    champagne: "#E8C6A0",
    cream: "#FAF6EE",
    taupe: "#6A5A50",
  },

  // Personalized quotes only — no fixed public pricing.
  services: [
    {
      id: "new-website",
      icon: "layout",
      title: "New Website Design",
      text: "Professional, mobile-friendly websites designed to help your business make a great first impression and turn visitors into customers.",
      preset: "New Website",
    },
    {
      id: "redesign",
      icon: "redesign",
      title: "Website Redesign",
      text: "Already have a website? We'll give it a fresh, modern look with improved navigation, updated design, and a better experience across devices.",
      preset: "Redesign",
    },
    {
      id: "custom-features",
      icon: "features",
      title: "Custom Features & Interactive Tools",
      text: "Go beyond a basic website with instant estimate calculators, interactive quizzes, quote forms, product finders, and other custom functionality.",
      preset: "Custom Feature",
    },
    {
      id: "managed-care",
      icon: "care",
      title: "Managed Hosting & Website Care",
      text: "Reliable hosting, technical upkeep, and ongoing website care so you can focus on running your business.",
      preset: "Other",
    },
  ],

  hostingStatement:
    "All websites we build and host include a required monthly managed hosting and care plan. Your personalized proposal will clearly outline both the one-time project cost and ongoing monthly fee before you commit.",

  portfolio: [
    {
      id: "just-call-paul",
      title: "Just Call Paul",
      category: "Home Services & Instant Estimates",
      url: "https://www.justcallpaul352.com/",
      image: "/portfolio/just-call-paul.jpeg",
      description:
        "A professional home and property services website featuring service information, customer inquiries, and an interactive instant-estimate calculator.",
      features: [
        "Interactive instant-estimate calculator",
        "Detailed service information pages",
        "Customer inquiry & estimate-request forms",
        "Mobile-friendly design built to convert visitors",
      ],
    },
    {
      id: "fast-track-to-health",
      title: "Fast Track To Health",
      category: "Interactive Supplement Finder",
      url: "https://wellness-matcher.preview.emergentagent.com/",
      image: "/portfolio/fast-track-to-health.jpeg",
      description:
        "A custom interactive supplement finder that guides visitors through a wellness questionnaire and provides personalized supplement recommendations.",
      features: [
        "Interactive wellness questionnaire",
        "Personalized supplement recommendations",
        "Guided, friendly step-by-step experience",
      ],
    },
    {
      id: "stephanie-rose",
      title: "Stephanie Rose",
      category: "Professional Wellness Website",
      url: "https://health-advisor-33.preview.emergentagent.com/",
      image: "/portfolio/stephanie-rose.jpeg",
      description:
        "A professional wellness website showcasing expertise, digital programs, consultation services, and a polished personal brand.",
      features: [
        "Digital programs & expertise showcase",
        "Consultation services with clear calls to action",
        "Polished, cohesive personal brand",
      ],
    },
  ],

  // Editable founder note for the About page (photo placeholder alongside).
  founderBlurb:
    "A personal note and photo from our founder are on the way. This space is reserved for the story behind the studio — check back soon.",

  // Photography used inside the hero device mockups (illustrative example sites).
  mockupImages: {
    landscapingHero:
      "https://images.unsplash.com/photo-1743167548878-6069e48779c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBsYW5kc2NhcGluZyUyMGdhcmRlbiUyMG1hbmljdXJlZCUyMGxhd24lMjBwYXRpbyUyMHBvb2x8ZW58MHx8fHwxNzkxNzMyNjYxfDA&ixlib=rb-4.1.0&q=85",
    landscapingThumb1:
      "https://images.unsplash.com/photo-1786550028419-2f6696405f60?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6OTV8MHwxfHNlYXJjaHwzfHxsYW5kc2NhcGluZyUyMGdhcmRlbiUyMGJlZCUyMHN0b25ld29yayUyMHBhdGlvJTIwZGVzaWdufGVufDB8fHx8MTc5MTczMjY2OXww&ixlib=rb-4.1.0&q=85",
    landscapingThumb2:
      "https://images.unsplash.com/photo-1734303023491-db8037a21f09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NzF8MHwxfHNlYXJjaHwyfHxsYXduJTIwY2FyZSUyMG1vd2luZyUyMGdyYXNzJTIwZ2FyZGVuJTIwaGVkZ2V8ZW58MHx8fHwxNzkxNzMyNjY5fDA&ixlib=rb-4.1.0&q=85",
    pressureHero:
      "https://images.unsplash.com/photo-1605146768851-eda79da39897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NzN8MHwxfHNlYXJjaHwxfHxwcmVzc3VyZSUyMHdhc2hpbmclMjBkcml2ZXdheSUyMGNsZWFuJTIwaG9tZSUyMGV4dGVyaW9yJTIwcHJlc3N1cmUlMjB3YXNoZXJ8ZW58MHx8fHwxNzkxNzMyNjYxfDA&ixlib=rb-4.1.0&q=85",
    pressureThumb:
      "https://images.unsplash.com/photo-1781637202423-33ec5b47e52e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NzN8MHwxfHNlYXJjaHwzfHxwcmVzc3VyZSUyMHdhc2hpbmclMjBkcml2ZXdheSUyMGNsZWFuJTIwaG9tZSUyMGV4dGVyaW9yJTIwcHJlc3N1cmUlMjB3YXNoZXJ8ZW58MHx8fHwxNzkxNzMyNjYxfDA&ixlib=rb-4.1.0&q=85",
  },

  marqueeItems: [
    "Pressure Washing",
    "Handyman",
    "Landscaping",
    "House Painting",
    "Cleaning",
    "Home Remodeling",
    "Small Business Websites",
  ],

  projectTypes: ["New Website", "Redesign", "Custom Feature", "Other"],
  timeframeOptions: ["As soon as possible", "Within 2–4 weeks", "1–2 months", "Flexible"],
};

export default brand;
